module.exports = __webpack_public_path__ + "media/svg/CheckSquareFill-primary-66d24d27.svg";